import React, { useState } from 'react';
import styled from 'styled-components';
import { Typo, Icon as _Icon } from 'tmt-ui-kit';
import moment from 'moment-timezone';
import { useDispatch } from 'react-redux';

import { actions as tripActions } from '~/redux/reducers/trip';

const Container = styled.div`
  width: fit-content;
  margin: 0 auto;
  padding: 60px 0;
`;

const Title = styled(Typo.HeaderTwo)`
  text-align: center;
  margin-bottom: 10px;
`;

const CouponContainer = styled.div`
  cursor: pointer;
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr;
  width: fit-content;
  background: #e6e6e6;
  border-radius: 12px;
  margin: 12px auto 0px;
`;

const TextCoupon = styled(Typo.HeaderTwo)`
  font-size: 50px !important;
  letter-spacing: 2px;
  font-weight: 600 !important;
  text-align: center;
  padding: 5px 30px 5px 15px;

  @media(max-width: 600px) {
    font-size: 24px !important;
  }
`;

const Clip = styled.div`
  padding: 4px 0px;
  /* top: 32px; */
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: ${props => props.theme.white};
`;

const RightClip = styled(Clip)`
  right: -15px;
`;

const LeftClip = styled(Clip)`
  left: -15px;
`;

const CopyIconContainer = styled.div`
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px dashed;
  height: 100%;
  margin-left: 12px;
  width: 68px;
  padding: 0px 6px;
`;

const CopyIcon = styled(_Icon)`
  font-size: ${({ isCopied }) => (isCopied ? '34px' : '30px')};
  width: 30px;
  height: 30px;
  text-align: center;
  color: ${({ isCopied, theme }) => (isCopied ? theme.orange : theme.darkBlue)};
  ${({ isCopied }) => isCopied && `
    font-weight: 600;
    margin-top: -4px;
  `}
`;

const Detail = styled.div`
  width: 100%;
  margin-top: 40px;
  border-radius: 12px;
  box-shadow: 0px 2px 6px rgba(128, 128, 128, 0.15);
`;

const RowDetail = styled.div`
  display: grid;
  grid-template-columns: 170px 1fr;
  @media(max-width: 600px) {
    grid-template-columns: 134px 1fr;
  }
`;

const ColDetail = styled.div`
  padding: 16px 18px 16px 34px;
  ${({ isBorder }) => isBorder && 'border-bottom: 1px solid #1313131c;'}
  @media(max-width: 600px) {
    padding: 8px 10px 8px 18px;
    font-size: 14px;
  }
`;

const TitleCol = styled.div`
  padding: 16px 18px;
  background: ${props => props.theme.orange};
  font-size: 16px;
  color: ${props => props.theme.white};
  text-align: center;
  ${({ isBorder }) => isBorder && 'border-bottom: 1px solid #ffffff70;'}
  ${({ status }) => `border-${status === 'first' ? 'top' : 'bottom'}-left-radius: 12px;`}

  @media(max-width: 600px) {
    padding: 8px 10px;
    font-size: 14px;
  }
`;

const getTravelPeriod = (r) => {
  let text = 'Anytime';
  if (r) {
    if (r.min_trip_date && r.max_trip_date) text = `${moment(r.min_trip_date).format('DD MMM YYYY')} - ${moment(r.max_trip_date).format('DD MMM YYYY')}`;
    else if (r.min_trip_date) text = `${moment(r.min_trip_date).format('DD MMM YYYY')} - Anytime`;
    else if (r.max_trip_date) text = `Anytime - ${moment(r.max_trip_date).format('DD MMM YYYY')}`;
  }
  return text;
};

const PromoTopic = (props) => {
  const { article } = props;
  const { redeem_id: redeem } = article;

  const dispatch = useDispatch();
  const textTravelPeriod = getTravelPeriod(redeem);
  const logParams = { id: article._id, name: article.title, slug: article.slug };
  const textBookingPeriod = (redeem && redeem.expires_at)
    ? `Now - ${moment(redeem.expires_at).format('DD MMM YYYY')}`
    : 'Anytime';

  const [isCopied, setIsCopied] = useState(false);
  const onCopyCode = (e) => {
    e.preventDefault();
    setIsCopied(true);
    const textField = document.createElement('textarea');
    textField.innerText = (redeem && redeem.code) || '';
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    setTimeout(() => setIsCopied(false), 1000);
    dispatch(tripActions.logClickCopyPromo(logParams));
  };

  return (
    <Container>
      <Title>Promo Code :</Title>
      {redeem && redeem.code && (
        <CouponContainer onClick={onCopyCode}>
          <div>
            <CopyIconContainer>
              <RightClip />
              <CopyIcon isCopied={isCopied} name={isCopied ? 'check' : 'copy'} />
              <LeftClip />
            </CopyIconContainer>
          </div>
          <div>
            <TextCoupon>{redeem.code}</TextCoupon>
          </div>
        </CouponContainer>
      )}
      <Detail>
        <RowDetail>
          <TitleCol isBorder status="first">Booking period</TitleCol>
          <ColDetail isBorder>{textBookingPeriod}</ColDetail>
        </RowDetail>
        <RowDetail>
          <TitleCol status="second">Travel period</TitleCol>
          <ColDetail>{textTravelPeriod}</ColDetail>
        </RowDetail>
      </Detail>
    </Container>
  );
};

export default PromoTopic;
